import { chicagoTimeZone, DatePresetOptions } from "@enfusion-ui/utils";
import { styled } from "@enfusion-ui/web-core";
import Popover, { positionDefault } from "@reach/popover";
import isTouchDevice from "is-touch-device";
import React, { useState } from "react";
import { Select } from "../Select";
const TooltipContainer = styled.div `
  display: flex;
  flex-direction: row;
  background: var(--background-accent);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.25em;
  height: 25px;
  min-width: 300px;
`;
const TouchDeviceDateContainer = styled(TooltipContainer) `
  background: none;
  min-width: 0;
  height: 23px;
`;
const ToolTip = styled.div `
  margin-left: 4px;
`;
const TouchDeviceDateLabel = styled(ToolTip) `
  font-size: 13px;
`;
const Info = styled.div `
  margin-left: auto;
  font-size: 13px;
  font-style: italic;
  margin-top: 2px;
  padding-left: 5px;
`;
const TouchDeviceTimezoneLabel = styled(Info) `
  font-size: 10px;
`;
const getOption = (value, options) => {
    if (typeof value === "string") {
        return options.find((i) => i.value === value);
    }
};
export const DatePresetSelect = ({ onChange, value, timezone = chicagoTimeZone, clearable, optionSet = "value", dataE2EId, ...rest }) => {
    const [tooltip, setTooltip] = useState("");
    const [showTooltip, setShowTooltip] = useState(false);
    const ref = React.useRef(null);
    const selectedValue = React.useMemo(() => {
        const option = value
            ? getOption(value, DatePresetOptions[optionSet])
            : null;
        setTooltip(option?.tooltip?.(timezone) || "");
        return option;
    }, [value, timezone, optionSet]);
    const handleChange = (selectedOption) => {
        onChange && onChange(selectedOption ? selectedOption.value : null);
        setShowTooltip(false);
        selectedOption?.tooltip && setTooltip(selectedOption.tooltip(timezone));
    };
    const handleMouseEnter = () => {
        tooltip && setShowTooltip(true);
    };
    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    return (React.createElement("div", { ref: ref, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, style: { flex: 1, padding: "0 1px" } },
        React.createElement(Select, { value: selectedValue, onChange: handleChange, options: DatePresetOptions[optionSet], minWidth: 130, clearable: clearable, inputId: dataE2EId ?? "date-preset-selection-id", ...rest }),
        showTooltip && !isTouchDevice() && (React.createElement(Popover, { targetRef: ref, position: positionDefault },
            React.createElement(TooltipContainer, null,
                React.createElement(ToolTip, null, tooltip),
                React.createElement(Info, null,
                    "(",
                    timezone,
                    " timezone)")))),
        isTouchDevice() ? (React.createElement(TouchDeviceDateContainer, null,
            React.createElement(TouchDeviceDateLabel, null, tooltip),
            React.createElement(TouchDeviceTimezoneLabel, null,
                "(",
                timezone,
                " timezone)"))) : null));
};
